import queryString from 'query-string';
import { cleanObject } from './cleanObject';
import { LangEnum } from '@enums';

export const convertToQueryString = (query, lang = LangEnum.ALL): string => {
  // TODO: Remove it in a couple of months
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // delete query.lang;
  if (query && !query?.lang) {
    query.lang = lang;
  }
  const result = queryString.stringify(cleanObject(query), { arrayFormat: 'comma' });
  return result ? `?${result}` : `?lang=${lang}`;
};
